<template>
  <div class="animated fadeIn">
    <flash-message transitionIn="animated swing"></flash-message>
    <b-row>
      <b-col xs="12" lg="12">
        <b-card>
          <div slot="header">
            Update My Details
          </div>
          <user-form
            :user="user"
            :add-option="false"
          ></user-form>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col xs="12" lg="12">
        <b-card>
          <div slot="header">
            Change Password
          </div>
          <change-password-form :user-id="user.id"></change-password-form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>

import {RepositoryFactory} from "../services/repositories/RepositoryFactory";
import {User} from "../models/User";
import {UserStorage} from "../services/LocalStorage/UserStorage";
import ChangePasswordForm from "../components/users/ChangePasswordForm";
import UserForm from "../components/users/UserForm";

export default {
  name: 'profile',
    components: {
      UserForm,
      ChangePasswordForm
    },
    data() {
      return {
          user: new User(),
      }
    },
    created() {
      RepositoryFactory
        .get('user')
        .getUser(UserStorage.getUserId())
        .then(
          response => (
            this.user = response.data.data
          )
        )
    },
}
</script>

